import { ml } from "../../../../core/common/matrixlib";
import {
    IPrintFunction,
    IGlobalPrintFunctionParams,
    IPrintFunctionParams,
} from "../../../../core/printinterface/PrintFunction";
import { IPrintGlobals } from "../../../../core/printinterface/PrintProcessorInterfaces";
import { PrintProcessor } from "../../PrintProcessor";

export type { IIncludePrimitiveParams };
export { IncludePrimitive };

interface IIncludePrimitiveParams extends IPrintFunctionParams {
    class?: string; // default:"includeInfo". class for outermost container
    details?: number; // default 0 (project), 1 (revision), 2 (item-vrevision)
}

class IncludePrimitive implements IPrintFunction {
    static uid = "includeinfo";

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    getGroup() {
        return "Item";
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    getHelp() {
        return `<h1>Renders include info of item</h1>
<p>Options</p>
<pre>
    class?:string // default:"includeInfo". class for outermost container
    details?:number // default 0 (project), 1 (revision), 2 (item-vrevision)
</pre>`;
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    getName() {
        return "Info about source of include";
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async renderAsync(
        overwrites: IGlobalPrintFunctionParams,
        paramsCaller: IIncludePrimitiveParams,
        itemOrFolderRef: string,
        object: JQuery,
        mf: JQuery,
        globals: IPrintGlobals,
        possibleTargets: string[],
        onError: (message: string) => void,
    ) {
        const defaults: IIncludePrimitiveParams = {
            class: "includeInfo",
            details: 0,
        };

        const params = <IIncludePrimitiveParams>ml.JSON.clone({
            ...defaults,
            ...overwrites.customer[IncludePrimitive.uid],
            ...paramsCaller,
            ...overwrites.project[IncludePrimitive.uid],
            ...overwrites.section[IncludePrimitive.uid],
        });

        let attr = "included_from_project";
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        if (params.details == 1) {
            attr = "included_from_version";
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
        } else if (params.details == 2) {
            attr = "included_from_item";
        }

        let attrVal = object[0].getAttribute(attr);

        return `<span class='${params.class}'>${attrVal ? attrVal : ""}</span>`;
    }
}

PrintProcessor.addFunction(IncludePrimitive.uid, new IncludePrimitive());
